export const localTranslationTable = {
  "feel_great_coaching": "Feel Great Coaching",
  "unicity_go": "Unicity Go",
  "unicity_go_subtitle": "The official mobile app for Unicity Distributors.",
  "unicity_go_open": "Open",
  "rank_qualifications": "Rank qualifications",
  "rank": "Rank",
  "month": "Month",
  "leg": "Leg",
  "in_this_leg": "in this leg",
  "learn_more_about_rank_advancement": "Learn more about rank advancement",
  "centurion_qualifications": "Centurion qualifications",
  "see_more": "See more",
  "recent_activity": "Recent activity",
  "see_all": "See all",
  "dashboard_explained": "Dashboard explained",
  "pv": "PV",
  "tv": "TV",
  "provide_feedback": "Provide feedback",
  "log_out": "Log Out",
  "manager": "Manager",
  "senior_manager": "Sr. Manager",
  "executive_manager": "Exec. Manager",
  "director": "Director",
  "senior_director": "Sr. Director",
  "executive_director": "Exec. Director",
  "presidential_director": "Pres. Director",
  "presidential_sapphire": "Pres. Sapphire",
  "presidential_ruby": "Pres. Ruby",
  "presidential_diamond": "Diamond",
  "dashboard": "Dashboard",
  "members": "Members",
  "customers": "Customers",
  "partners": "Partners",
  "action_hub": "Action Hub",
  "centurion": "Centurion",
  "referral_links": "Referral Links",
  "library": "Library",
  "help_center": "Help Center",
  "search_by_id_name_phone_etc": "Search by ID, name, phone, email or location",
  "name_uid": "Name/UID",
  "date_joined": "Date joined",
  "orders": "Orders",
  "referrals": "Referrals",
  "last_order_date": "Last order date",
  "last_order_pv": "Last order PV",
  "last_order_sub_total": "Last order Sub Total",
  "subscription": "Subscription",
  "country_state": "Country/state",
  "purchase_period": "Purchase period",
  "products": "Products",
  "subscriptions": "Subscriptions",
  "manage_columns": "Manage columns",
  "members_per_page": "Members per page",
  "partners_per_page": "Partners per page",
  "my_frontline": "My Frontline",
  "frontline": "Frontline",
  "sort_by": "Sort by",
  "show": "Show",
  "activity": "Activity",
  "auto_generated_follow_ups": "Auto-generated follow ups",
  "new_feel_great_members": "New Feel Great Members",
  "order_reminders": "Order reminders",
  "action_hub_explained": "Action Hub explained",
  "centurion_sales": "Centurion sales",
  "centurion_explained": "Centurion explained",
  "award_progress": "Award progress",
  "bonuses": "Bonuses",
  "level": "Level",
  "completed": "Completed",
  "sales": "Sales",
  "sales_per_page": "Sales per page",
  "referral_alert_text": "These are universal links that will adjust based off your prospect's location and language.",
  "referral_alert_link_text": "Learn more",
  "feel_great": "Feel Great",
  "feel_great_subtext": "The shopping site for Feel Great (ufeelgreat.com).",
  "show_link": "Show my referral link",
  "show_code": "Show my referral code",
  "distributor_enrollment_subtext": "Use this link to directly enroll prospects as new Distributors on your team.",
  "distributor_enrollment": "Distributor Enrollment",
  "ufg_upsell_title": "UFG Upsell",
  "ufg_upsell_description": "This setting determines whether or not your customers are presented with an upsell during their checkout experience.",
  "ufg_upsell_toggle_on": "ON",
  "ufg_upsell_toggle_off": "OFF",
  "ufg_upsell_toggle_label": "(Customer Upsells)",
  "website_subtext": "Use this page to redirect users to the Unicity store or product page.",
  "country": "Country",
  "website": "Website",
  "page": "Page",
  "page_language": "Page language",
  "countries": "Countries",
  "websites": "Websites",
  "pages": "Pages",
  "page_languages": "Page languages",
  "your_referral_link": "Your referral link",
  "link_has_been_updated": "The link was successfully updated.",
  "referral_links_explained": "Referral Links explained",
  "additional": "Additional",
  "custom_link": "Custom links",
  "no_activities_to_display": "There are no activities to display.",
  "see_full_profile": "See full profile",
  "phone_unavailable": "Phone number currently unavailable",
  "email_unavailable": "Email currently unavailable",
  "timezone_unavailable": "Timezone currently unavailable",
  "address_unavailable": "Address currently unavailable",
  "country_unavailable": "Country currently unavailable",
  "no_orders_text": "There are currently no orders to display for this person.",
  "order_details": "Order details",
  "tracking_number": "Tracking number",
  "shipping": "Shipping",
  "billing_address": "Billing address",
  "summary": "Summary",
  "prepared_to_ship": "Prepared to ship",
  "shipped": "Shipped",
  "one_time_purchase": "One-time purchase",
  "success_tracker": "Success tracker",
  "updated": "Updated",
  "estimated_commissions": "Estimated Commissions",
  "final_commissions": "Final Commissions",
  "total_sales": "total sales",
  "total_orders": "Total Orders",
  "subscription_orders": "Subscription Orders",
  "new_customers": "New Customers",
  "updated_just_now": "Updated just now",
  "updated_min_ago": "Updated {{param1}} min ago",
  "updated_hours_ago": "Updated {{param1}} h ago",
  "see_frontline": "See Frontline",
  "distributor": "Distributor",
  "distributor_full": "Distributor",
  "affiliate": "Affiliate",
  "phase_1_full": "Phase 1",
  "associate_full": "Associate",
  "non_manager_full": "Non-Manager",
  "manager_full": "Manager",
  "senior_manager_full": "Senior Manager",
  "director_full": "Director",
  "senior_director_full": "Senior Director",
  "executive_manager_full": "Executive Manager",
  "executive_director_full": "Executive Director",
  "presidential_director_full": "Presidential Director",
  "presidential_sapphire_full": "Presidential Sapphire",
  "presidential_ruby_full": "Presidential Ruby",
  "presidential_diamond_full": "Diamond",
  "upgrade_link_subtext": "Use this link to enable your Members to join as Distributors on your team.",
  "january": "January",
  "february": "February",
  "march": "March",
  "april": "April",
  "may": "May",
  "january_short": "Jan",
  "february_short": "Feb",
  "march_short": "Mar",
  "april_short": "Apr",
  "may_short": "May",
  "june_short": "Jun",
  "july_short": "Jul",
  "august_short": "Aug",
  "september_short": "Sep",
  "october_short": "Oct",
  "november_short": "Nov",
  "december_short": "Dec",
  "june": "June",
  "july": "July",
  "august": "August",
  "september": "September",
  "october": "October",
  "november": "November",
  "december": "December",
  "new_feel_great_alert_bold": "Here are the people who made their first Feel Great purchase in the last 2 weeks.",
  "new_feel_great_alert_not_bold": "Contact them so they know they can reach out to you.",
  "order_reminders_alert_bold": "Five weeks have passed since these Members made an order.",
  "order_reminders_alert_not_bold": "You may want to check in with them.",
  "of": "of",
  "new": "new",
  "order": "order",
  "made_a": "made a",
  "descending": "Descending",
  "ascending": "Ascending",
  "name": "Name",
  "total_ov": "Total OV",
  "new_partners": "New Partners",
  "ov_to_next_rank": "OV to Next Rank",
  "contact": "Contact",
  "referred_by": "Referred by",
  "first_order_date": "First Order Date",
  "count": "Count",
  "last_purchase": "Last purchase",
  "all_statuses": "All statuses",
  "subscribed": "Subscribed",
  "not_subscribed": "Not subscribed",
  "apply_filter": "Apply Filter",
  "cancel": "Cancel",
  "filter": "Filter",
  "made_referrals": "Made referrals",
  "no_referrals": "No referrals",
  "purchases": "Purchases",
  "statuses": "Statuses",
  "members_with_orders": "Members with orders",
  "never_purchased": "Never purchased",
  "all_products": "All products",
  "other_products": "Others products",
  "all_time": "All time",
  "last_seven_days": "Last 7 days",
  "last_thirty_days": "Last 30 days",
  "last_ninety_days": "Last 90 days",
  "last_year": "Last Year",
  "custom_range": "Custom range",
  "business": "Business",
  "resources": "Resources",
  "member": "Member",
  "go_to_referral_links": "Go to Referral Links",
  "empty_list": "Empty list",
  "custom_no_rows_overlay_text": "There are no Members associated with your account. Share your referral link to start building your business.",
  "clear_filters": "Clear Filters",
  "filter_no_rows_overlay_text": "Try adjusting your search or filters to see more.",
  "no_results_to_display": "No results to display",
  "no_search_results_overlay1": "There are no search results matching your criteria. Please try again or clear the current search.",
  "clear_search": "Clear Search",
  "too_many_hits_overlay1": "Please add a filter",
  "too_many_hits_overlay2": "We can only display 10,000 records at one time. Please apply at least one filter to limit your records.",
  "too_many_hits_overlay3": "For example, you can filter out users who have not purchased this year.",
  "go_back": "Go back",
  "action_hub_overlay1": "You're all done",
  "action_hub_overlay2": "There are no more tasks on this list.",
  "no_sales": "No Sales",
  "no_sales_overlay1": "There are no sales for selected period. Please change the period or refresh the page.",
  "clear_filter": "Clear Filter",
  "partners_clear_filter_overlay1": "No results to display",
  "partners_clear_filter_overlay2": "Try adjusting or clearing the filter to see more.",
  "empty_frontline": "Empty frontline",
  "partners_empty_frontline1": "This user's frontline is empty.",
  "return_to_partners": "Return to Partners",
  "no_partners_yet": "No partners yet",
  "partner_no_rows_overlay1": "Use the Upgrade or Enroll links to add Distributors to your frontline.",
  "please_add_a_filter": "Please add a filter",
  "too_many_hits1": "We can only display 10,000 records at one time. Please apply at least one filter to limit your records.",
  "too_many_hits2": "For example, you can filter out users who have not purchased this year.",
  "asc": "Asc",
  "desc": "Desc",
  "active": "Active",
  "inactive": "Inactive",
  "suspended": "Suspended",
  "sort": "Sort",
  "inactive_explained": "* Inactive - have not made a qualifying PV purchase in the past 2 months",
  "select_period": "Select period",
  "partials": "Partials",
  "partials_alert_bold": "Members who created an account but did not complete their purchase.",
  "partials_alert_not_bold": "Partials are only available for follow up for 2 weeks.",
  "availability": "Availability",
  "days_left": "days left",
  "not_available": "Not available",
  "error": "Error",
  "access_denied": "Access denied.",
  "there_was_an_error": "There was an error",
  "all": "All",
  "genealogy": "Genealogy",
  "stats": "Stats",
  "active_partners": "Active Partners",
  "total_members": "Total Members",
  "purchased_in_last_60_days": "Purchased in last 60 days",
  "active_subscribers": "Active subscribers",
  "members_with_referrals": "Members with referrals",
  "hide": "Hide",
  "note": "Note",
  "generic_error": "An error has occurred. Please reload the page and try again. If the error persists, please contact support.",
  "full_profile_information_error": "Full profile information for non U.S. Members may not be visible for all requests.",
  "build_your_network": "Build your network of Members and we will help you to organize follow ups.",
  "no_further_activities": "No further activities to display at the moment.",
  "day_left": "day left",
  "language": "Language",
  "change": "Change",
  "apply": "Apply",
  "change_language": "Change Language",
  "english": "English",
  "espanol": "Español",
  "login": "Login",
  "forgot_password": "Forgot password",
  "password": "Password",
  "email_address_or_unicity_id": "Email address or Unicity ID",
  "login_or_password_is_incorrect": "Login or password is incorrect. Please try again.",
  "reach": "Reach",
  "date": "Date",
  "commission_month": "Commission Mo.",
  "subtotal": "Subtotal",
  "taxes": "Taxes",
  "total": "Total",
  "copied_to_clipboard": "Copied {{param1}} to clipboard",
  "what_is_next_rank": "What is \"Next rank\"?",
  "next_rank_is": "Next rank is the rank next in order based on this person's progression.",
  "learn_more": "Learn more",
  "complete_this_goal_to_qualify_for_next_rank": "Complete this goal to qualify for a rank",
  "referred_by_line1": "If this Member was referred by another Member, their name will appear here.",
  "referred_by_line2": "You may want to contact the referrer before contacting your new Member.",
  "today": "Today",
  "yesterday": "Yesterday",
  "start_date": "Start date",
  "end_date": "End date",
  "sign_out": "Sign out",
  "from": "From",
  "to": "To",
  "next": "Next",
  "no_subscription": "No subscription",
  "no": "No",
  "yes": "Yes",
  "retail": "Retail",
  "wholesale": "Wholesale",
  "preferred": "Preferred",
  "new_library": "New Library",
  "beta": "Beta",
  "settings": "Settings",
  "my_profile": "My Profile",
  "personal_information": "Personal Information",
  "sponsor_and_enroller": "Sponsor & Enroller",
  "communications": "Communications",
  "security": "Security",
  "distributor_profile": "Distributor profile",
  "profile_photo": "Profile photo",
  "your_profile_picture_may_appear": "Your profile photo may appear with your referral link or in Unicity Office for other Distributors to see",
  "change_photo": "Change photo",
  "remove_photo": "Remove photo",
  "display_name": "Display name",
  "display_name_subheader": "This will display on ufeelgreat.com when customers use your referral link",
  "save_changes": "Save Changes",
  "add_photo": "Add photo",
  "remove": "Remove",
  "upload": "Upload",
  "choose_file": "Choose file",
  "add": "Add",
  "unauthorized_login": "As a Member you cannot access Unicity Office. Learn more about becoming a Distributor in our",
  "member_help_center": "Member Help Center",
  "member_help_center_url": "https://help.unicity.com/hc/en-us",
  "provide_feedback_url": "https://docs.google.com/forms/d/e/1FAIpQLScCfmTluRYiVUV6fRGfhptQ26FmUfTWooZluoS7m4zKn7fxGg/viewform",
  "first_name": "First name",
  "last_name": "Last name",
  "reset": "Reset",
  "name_required": "Name is required",
  "name_at_least": "Must be at least {{param1}} characters",
  "name_at_most": "Must be at most {{param1}} characters",
  "name_invalid_characters": "Contains invalid characters or spaces",
  "name_not_allowed": "Name is not allowed",
  "name_not_trailing_spaces": "Name must not contain leading or trailing spaces",
  "error_5006": "Unable to upload file. Please select a valid image file with extension .png, .jpg, .jpeg or .gif.",
  "relevance": "Relevance",
  "earnings": "Earnings",
  "download": "Download",
  "processing_fees": "Processing fees",
  "week": "Week",
  "month_end": "Month end",
  "statement": "statement",
  "account_info": "Account info",
  "name_and_address": "Name and address",
  "well_use_this_information": "We'll use this information for your tax documents",
  "full_name": "Full name",
  "address": "Address",
  "city": "City",
  "zip_code": "Zip code",
  "tax_id_ssn": "Tax ID/SSN",
  "optional": "Optional",
  "state": "State",
  "sponsor": "Sponsor",
  "enroller": "Enroller",
  "reload": "Reload",
  "address1_not_blank": "Address Line 1 cannot be left blank.",
  "error_validate_update_address": "An error has occurred while attempting to validate and update your name and address. Please review your changes. If this error persists, please contact support.",
  "placement_program": "Placement program",
  "contact_info": "Contact info",
  "email_address": "Email address",
  "current_email_address": "Current email address",
  "change_email_address": "Change email address",
  "phone_number": "Phone number",
  "current_phone_number": "Current phone number",
  "change_phone_number": "Change phone number",
  "reauthenticate_to_continue": "Re-authenticate to continue",
  "continue": "Continue",
  "email_id_is_not_correct": "Email address or Unicity ID is not correct",
  "new_email_address": "New email address",
  "new_phone_number": "New phone number",
  "confirm_changes": "Confirm changes",
  "confirm_new_email_address": "Confirm new email address",
  "field_cannot_be_empty": "This field cannot be empty.",
  "password_min_length": "Password must be at least {{param1}} characters.",
  "invalid_email_address": "Invalid email address.",
  "email_addresses_do_not_match": "Email must match.",
  "successful_email": "Your email address was successfully changed to",
  "successful_phone": "Your phone number was successfully changed to",
  "statements": "Statements",
  "year": "Year",
  "statements_per_page": "Statements per page",
  "upcoming": "Upcoming",
  "pending": "Pending",
  "share_feel_great": "Share Feel Great",
  "share_feel_great_subheader": "Setup your Feel Great referral link and code. You can change this 2 times per calendar year",
  "referral_link": "Referral link",
  "referral_code": "Referral code",
  "referral_link_updated_alert": "Your referral link and code were successfully updated",
  "edit": "Edit",
  "add_custom_phrase": "Add custom phrase",
  "referral_link_modal_header": "Edit referral link and code",
  "confirm": "Confirm",
  "insufficient_code_length_error": "Phrase must be at least 3 characters.",
  "allowed_code_change_count_exceeded_error": "Phrase change limit reached.",
  "restricted_code_error": "Phrase is restricted.",
  "referralcode_already_assigned_error": "Phrase is already taken. Try another one.",
  "referral_code_max_length_error": "Phrase exceeds character limit. ",
  "shop_feel_great": "Shop Feel Great",
  "shop_unicity": "Shop Unicity",
  "unicity_news": "Unicity News",
  "latest_news": "Latest News",
  "read_more": "Read more",
  "failed_to_reauthenticate": "Failed to reauthenticate.",
  "share_feel_great_max_changes_reached": "You’ve already changed your referral link and code twice this year. You can do it again next year.",
  "referral_code_disallowed_phrase": "Your custom phrase is restricted.",
  "referral_code_includes_disallow_phrase": "Phrase is not allowed.",
  "name_restricted": "This name is restricted.",
  "full_name_restricted": "This first and last name is restricted.",
  "notes": "Notes",
  "no_notes_to_display": "No notes to display",
  "add_new_note": "Add new note",
  "add_note": "Add note",
  "created_on": "Created on",
  "edit_note": "Edit note",
  "remove_note": "Remove note",
  "load_more": "Load more",
  "edited_on": "Edited on",
  "add_note_placeholder": "Add note",
  "save_note": "Save note",
  "new_partners_help_text": "This column shows how many New Partners this Distributor has enrolled in their frontline this month.",
  "enroller_requester": "Enroller (requester)",
  "enroller_name": "Enroller name",
  "enroller_id_number": "Enroller ID number",
  "user_to_be_placed": "Distributor / Customer to be placed",
  "distributor_name": "Distributor name",
  "distributor_uid": "Distributor UID",
  "new_sponsor": "New sponsor",
  "sponsor_name": "Sponsor name",
  "sponsor_uid": "Sponsor UID",
  "select_month": "Select Month",
  "submit": "Submit",
  "field_is_required": "Field is required",
  "month_of_change": "Effective month of change",
  "customer": "Customer",
  "thank_you": "Thank you!",
  "uh_oh": "Uh oh!",
  "placement_success": "You will receive an email once your request has been reviewed.",
  "placement_failure": "We were unable to process your request. If you believe this is an error, please contact the Distributor Compliance team to process your request:",
  "placement_desc_short": "Unicity's Placement Program allows you to Place a new Distributor within their first sixty (60) days, by completing and submitting this form. For a Distributor to be Placed through this program, the following conditions must be met...",
  "placement_desc_long1": "Unicity's Placement Program allows you to Place a new Distributor within their first sixty (60) days, by completing and submitting this form. For a Distributor to be Placed through this program, the following conditions must be met:",
  "placement_desc_long2": "New Distributor’s Enroller and Sponsor are the same person;",
  "placement_desc_long3": "Placement request must be submitted by the original Enroller/Sponsor;",
  "placement_desc_long4": "Requested Sponsor must be in the Downline of the current Enroller/Sponsor.",
  "placement_desc_long5": "Sponsor change requests that fall outside of the first sixty (60) days of the new Distributor can only be changed by following the Sponsor Change Process as outlined in Section 4 of the Unicity Policies and Procedures. Please be advised, that any Placement Requests submitted between the 3rd and 15th of the month will be processed after the 15th, due to the processing of Commissions. You will receive confirmation once the request has been completed.",
  "see_less": "See less",
  "customer_name": "Customer name",
  "customer_uid": "Customer UID",
  "invalid_uid": "Not a valid UID",
  "uncompressedTv": "TV",
  "notice": "Notice",
  "system_outage": "System Outage",
  "generic_ops_message": "We are currently experiencing a service disruption. Our team is actively working to resolve the issue.",
  "global_notice_message": "We will be working on some upgrades to our data systems across Unicity websites and mobile apps starting at 10 PM MST on January 10 (5 AM UTC, January 11). During this brief maintenance period, service may be interrupted. Thank you for your understanding!",
  "kyc": "KYC Documents",
  "kyc_subtitle": "Complete your KYC verification by emailing your documents to our Customer Service team.",
  "kyc_email_section_title": "Submit your documents by email",
  "kyc_email_section_desc": "Attach all four documents listed below and send them to:",
  "kyc_email_button": "Email Your Documents",
  "kyc_email_caption": "The email opens pre-filled with your <0>Distributor ID ({{param1}})</0> in the subject line so our team can match your documents to your account. <1>Submitting for another distributor?</1> Use their Distributor ID in the subject line instead.",
  "kyc_email_subject": "KYC Documents – {{param1}} – {{param2}}",
  "kyc_email_body": "Hello,\n\nPlease find my KYC documents attached:\n1. Distributor Agreement Form\n2. PAN Card\n3. Address Proof\n4. Cancelled Cheque or Bank Passbook\n\nDistributor ID: {{param1}}\nName: {{param2}}",
  "kyc_required_documents": "Required Documents",
  "kyc_required_documents_desc": "Every submission must include all four:",
  "kyc_doc_agreement_title": "Distributor Agreement Form",
  "kyc_doc_agreement_desc": "Both pages, duly completed and signed.",
  "kyc_doc_pan_title": "PAN Card",
  "kyc_doc_pan_desc": "A clear copy of your PAN card.",
  "kyc_doc_address_title": "Address Proof",
  "kyc_doc_address_desc": "A copy of a valid address proof document (front and back).",
  "kyc_doc_cheque_title": "Cancelled Cheque or Bank Passbook",
  "kyc_doc_cheque_desc": "A cancelled cheque, or the front page of your bank passbook.",
  "kyc_accepted_formats": "Accepted formats: JPEG, PNG, or PDF scans.",
  "kyc_before_you_send_title": "Before You Send",
  "kyc_before_you_send_p1": "All submitted documents must match the name, address, PAN details, and bank information provided during distributor registration. The same information must also be correctly filled in the Distributor Agreement Form.",
  "kyc_before_you_send_p2": "If KYC documents are not submitted within 30 days from the date of joining, the Distributorship ID will be suspended until the required documents are received.",
  "kyc_what_happens_next": "<0>What happens next:</0> our Customer Service team reviews your submission and will contact you if anything is missing or unclear.",
  "referralcode_reserved_error": "Referral code is reserved.",
  "go_now_text": "Go now",
  "head_backto_oldoffice": "Need to head back to Old Office?",
  "view_profile": "View profile",
  "no_news_error": "There are currently no announcements for your country.",
  "invalid_ssn_tin": "Not a valid SSN / TIN",
  "ssn_tin": "SSN / TIN",
  "are_you_sure": "Are you sure?",
  "reset_application": "Reset Application",
  "reset_application_confirm": "Are you sure? Refreshing the application will reset your cache for this application.",
  "ssn_tin_cannot_be_changed": "SSN / TIN cannot be changed once submitted.",
  "ssn_not_saved": "Unable to save Tax ID. Please contact Distributor Compliance.",
  "cedula_number": "Cédula number",
  "invalid_cedula": "Not a valid Cédula number",
  "cedula_cannot_be_changed": "Cédula number cannot be changed once submitted.",
  "cedula_needed": "This is used to claim your well-earned commissions. Please provide your Cédula number.",
  "go_to_cedula": "To process your commission, please enter your Cédula number.",
  "cedula_not_saved": "Unable to save Cédula number. Please contact Distributor Compliance.",
  "no_news_to_display": "No news to display",
  "not_active_legs_tooltip_text": "Active legs requirement not met",
  "view_all_statements": "View all statements",
  "search_results": "Search results",
  "no_search_results": "No search results",
  "go_back_to_partners": "Go back to Partners",
  "search_results_for": "Search results for",
  "no_search_results1": "There are no search results matching your criteria. Please try again. Use name, UID or email address.",
  "show_all_results_for": "Show all results for",
  "show_results_for": "Show results for",
  "discount": "Discount",
  "partners_toggle_text": "Include Members",
  "go_to_oo_header": "Legacy Office - Discontinuation",
  "go_to_oo_body1": "In order to focus our efforts on providing the best experience in the new Unicity Office, we will be discontinuing support for the old Unicity Office on July 11th. After this date, Distributors will no longer be able to access the old Office website.",
  "go_to_oo_body2": "Do you have any concerns with Old Office going away? Please provide any concerns or feedback here.",
  "electronic_id": "Electronic ID",
  "valid_from": "Valid from",
  "print_link": "Print ID",
  "level_Limit_alert": "You have reached your access limit",
  "level_Limit_tooltip": "In an effort to protect the data of Unicity customers, Distributors can only view as many levels on which they are paid.",
  "active_legs": "Active Legs",
  "active_legs_qualified": "You've hit your Active Legs requirement for this month!",
  "active_legs_unqualified": "You must have {{param1}} active legs to qualify for rank",
  "pv_qualified": "You've hit your PV requirement for this month!",
  "pv_unqualified": "Complete this goal to qualify for a rank",
  "tv_qualified": "You've hit your TV requirement for this month!",
  "tv_unqualified": "Complete this goal to qualify for a rank",
  "al": "AL",
  "too_many_requests": "You have exceeded the maximum number of allowed login attempts. Please wait one minute before trying again.",
  "missing_rank_info_alert": "We are unable to display your rank information. Please check back soon!",
  "paid": "Paid",
  "go_to_ssn_tin": "To process your commission, please enter your SSN/TIN.",
  "ssn_tin_needed": "This is used to claim your well-earned commissions. Simply provide your SSN or TIN.",
  "go_now_exclamation": "Go now!",
  "auto_refills": "Auto-Refills",
  "order_history": "Order History",
  "dashboard_referral_link": "Referral Link",
  "fg_referral_link": "This universal Feel Great referral link will adjust according to your prospect's location.",
  "tv_pv_requirements_not_met": "There are only {{param1}} days left to complete your {{param2}} goals!",
  "copy_link": "Copy link",
  "switch_to_short_link": "Switch to short link",
  "switch_to_long_link": "Switch to long link",
  "leg1": "Leg 1",
  "leg2": "Leg 2",
  "projected_earnings": "Projected Earnings",
  "statement_not_available": "Statement will be available on or before {{param1}}",
  "statement_available": "Statement is now available for download",
  "suspended_terminated_error": "Your account status does not currently allow you to login to Office. If you think this is an error, please reach out to Unicity Customer Service.",
  "dc_link": "DC@Unicity.com",
  "cancelled": "Cancelled",
  "processing": "Processing",
  "skip": "Skip",
  "value_feedback": "We value your feedback",
  "how_was_experience": "How's your experience with Office?",
  "submit_feedback": "Your rating is invaluable in helping us improve the experience in Office.",
  "ty_for_rating": "Thank you for the rating.",
  "submit_feedback_card": "Submit Feedback",
  "close": "Close",
  "unacceptable": "Unacceptable",
  "weak": "Weak",
  "acceptable": "Acceptable",
  "good": "Good",
  "excellent": "Excellent",
  "survey_modal_text": "How would you rate your experience with Office?",
  "success_tracker_error": "We are unable to display the information. Check back later!",
  "new_version_banner": "A new version of Office is available. The system will refresh automatically in {{param1}} seconds.",
  "reached_max_centurion_points": "Congratulations! Reaching 100 Centurion Count is a remarkable achievement that reflects your dedication and leadership. We look forward to seeing your continued success!",
  "total_centurion_count": "Total Centurion Count",
  "referral_code_invalid_characters": "Only alphanumeric characters are allowed. Spaces are not permitted.",
  "its_time_for": "It's {0} for {1}",
  "made_an": "made an",
  "last": "Last",
  "welcome_to_new_library": "Welcome to the Library, a resource center for everything that will support your business.",
  "getting_started": "Getting Started",
  "getting_started_description": "Check out documents that might be helpful to you",
  "documents": "Documents",
  "documents_description": "Check out documents that might be helpful to you",
  "events_description": "Check out events that might be helpful to you",
  "feel_great_description": "Documents that support the Feel Great system",
  "feel_great_pack": "Feel Great Pack",
  "product_resources": "Product Resources",
  "product_description": "Product profiles and information about what we currently offer",
  "unicity_branding": "Unicity Branding",
  "unicity_branding_description": "Product profiles and information about what we currently offer",
  "videos": "Videos",
  "videos_description": "Check out documents that might be helpful to you",
  "country_language": "Select country & language",
  "country_language_warning": "Changing your country and language affects the available documents and resources in your region.",
  "search_by_country": "Search by country",
  "view_document": "View Document",
  "open_link": "Open Link",
  "save_document": "Save this document",
  "send_link": "Send this link",
  "copy_link_in": "Copy link in {{param1}}",
  "download_in": "Download in {{param1}}",
  "link_copied": "Link copied!",
  "search_docs": "Search documents you need",
  "sorry_no_results": "Sorry, we couldn't find any results",
  "no_docs_available": "No documents available.",
  "no_docs_in_language": "No documents available in this language. Please select another language from the dropdown above.",
  "started_a": "started a",
  "subscription_low": "subscription",
  "made_their_first": "made their first",
  "is_now_a": "is now a",
  "theme": "Theme",
  "automatic": "Automatic",
  "automatic_description": "Use device settings",
  "light": "Light",
  "dark": "Dark",
  "events": "Events",
  "view_photo": "View Photo",
  "sign_up_now": "Sign Up Now",
  "popup_title": "Win a ticket to the Americas success trip!",
  "subtextKey": "Register for the 2025 Americas Convention before the March 19 webinar, and you’ll be entered to win a ticket to Unicity’s exclusive buyout of Royal Caribbean! Normally, you’d need to qualify for this all-inclusive luxury cruise—but a few lucky winners will experience it just by registering early.",
  "subtextKey2": "Secure your Convention ticket now for your chance to win!",
  "order_summary": "Order Summary",
  "order_total": "Order Total",
  "tax": "Tax",
  "total_pv": "Total PV",
  "volume": "Volume",
  "my_orders": "My Orders",
  "no_record_found": "No record found",
  "my_orders_subheader": "You can find your recent orders here",
  "order_number": "Order Number",
  "payment": "Payment",
  "shipping_to": "Shipping to",
  "download_invoice": "Download Invoice",
  "downloading_invoice": "Downloading Invoice...",
  "card_identified": "{{param1}} ending in {{param2}}",
  "not_shipped": "This product has not been shipped",
  "no-record-found": "No record found",
  "payment_method_and_type__BankDraftAlias_Capture": "Bank Draft",
  "payment_method_and_type__BankDraft_Capture": "Bank Draft",
  "payment_method_and_type__BankWire_IOU": "Bank Wire IOU",
  "payment_method_and_type__BankWire_record": "Bank Wire",
  "payment_method_and_type__Cash_IOU": "Cash IOU",
  "payment_method_and_type__Cash_record": "Cash",
  "payment_method_and_type__Check_record": "Check",
  "payment_method_and_type__Coupon_record": "Product coupon",
  "payment_method_and_type__CreditCardAlias_AuthorizeAndCapture": "Credit Card",
  "payment_method_and_type__CreditCard_AuthorizeAndCapture": "New Credit Card",
  "payment_method_and_type__CreditCard_IOU": "Credit Card IOU",
  "payment_method_and_type__CreditCard_record": "Manual Payment",
  "payment_method_and_type__DebitCard_record": "Debit Card",
  "payment_method_and_type__DebitCard_recordPOSDebit Card": "Terminal pay",
  "payment_method_and_type__EWalletToken_AuthorizeAndCapture": "E-Wallet",
  "payment_method_and_type__EWallet_AuthorizeAndCapture": "PayPal Eur",
  "payment_method_and_type__PocketAdjustment_AuthorizeAndCapture": "Cash Coupon",
  "payment_method_and_type__PocketAdjustment_AuthorizeAndCaptureCashCouponCashCoupon": "Pocket credit",
  "payment_method_and_type__StoreCredit_AuthorizeAndCapture": "Product Credit",
  "payment_method_and_type__undefined_record": "Manual Payment",
  "products_have_been_shipped": "Products have been shipped",
  "product_has_been_shipped": "Product has been shipped",
  "products_have_not_been_shipped": "Products have not been shipped",
  "product_has_not_been_shipped": "Product has not been shipped",
  "back_to_orders_page": "Back to Orders Page",
  "error_loading_order": "Error loading order",
  "error_loading_order_description": "Please check the link and try again or contact support.",
  "download_invoice_error": "Failed to download invoice. Please try again or contact support.",
  "delivered": "Delivered",
  "back_ordered": "Back ordered",
  "returned": "Returned",
  "canceled": "Canceled",
  "fulfilled": "Fulfilled",
  "ready_to_process": "Prepared to Ship",
  "unfulfilled": "Unfulfilled",
  "hold": "Hold",
  "product": "Product",
  "focus_mode": "Focus Mode",
  "new_caps": "New",
  "focus_mode_details": "Focus Mode: spotlights a single product on a clean, distraction-free page",
  "check_focus_mode": "Check out the new feature by going to the Referral Links page",
  "go": "Go",
  "library_redirect": "You'll be redirected to an older version of the platform",
  "library_being_updated": "The library you selected is currently being updated..",
  "error_boundary_title": "Something went wrong",
  "error_boundary_message": "We're having a little trouble right now. Our team is on it and things should be back soon.",
  "reload_page": "Reload Page",
  "back_to_home": "Back to Home",
  "vegas_method_title": "Congratulations!",
  "vegas_method_subtext": "You have registered for the <0>Las Vegas Method Seminar June 23-24, 2025</0> in the <0>Las Vegas Unicity Office</0>.<1></1><1></1> Please check your email for your confirmation and QR code to access the event. <1></1><1></1> If you have any questions, please email us at AmericasEvent@unicity.com.",
  "vegas_method_button_text": "OKAY",
  "sign_up_here": "Sign up here!",
  "vegas_method_qualification_desc": "You have qualified for the <0>Las Vegas Method Seminar December 8-9, 2025</0> at the <0>Las Vegas Unicity Office</0>. <1></1><1></1> Join us for this two-day workshop led by CEO Stewart Hughes. Learn the principles that fueled his success as a Unicity Distributor and now as the company owner. Elevate your business and enrich your life!",
  "dismiss": "Dismiss",
  "register_now": "Register Now",
  "registered": "Registered",
  "vegas_method_qualification_desc_card": "Congratulations! You’ve qualified for the Las Vegas Method Seminar in December—join CEO Stewart Hughes to elevate your business and life!",
  "no_earnings_data_available_for_the_month_of": "No earnings data available for the month of ",
  "no_earnings_data_available": "No earnings data available.",
  "member_caps": "MEMBER",
  "subscription_caps": "SUBSCRIPTION",
  "orders_caps": "ORDERS",
  "qty_caps": "QTY",
  "no_rows": "No rows",
  "mena_method_qualification_desc_card": "You have qualified for the Oman Method Seminar on September 12-13, 2025 at the St. Regis Al Mouj Muscat Resort. Join us for this two-day workshop led by CEO Stewart Hughes. Learn the principles that fueled his success as a Unicity Distributor and now as the company owner. Elevate your business and enrich your life!",
  "mena_method_qualification_desc": "You have qualified for the <0>Oman Method Seminar on September 12-13, 2025</0> at the <0>St. Regis Al Mouj Muscat Resort</0>. <1></1><1></1> Join us for this two-day workshop led by CEO Stewart Hughes. Learn the principles that fueled his success as a Unicity Distributor and now as the company owner. Elevate your business and enrich your life!",
  "distributor_recruitment": "Distributor Recruitment",
  "distributor_recruitment_description": "Resources for recruiting new distributors",
  "customer_acquisition": "Customer Acquisition",
  "customer_acquisition_description": "Tools for acquiring new customers",
  "team_development": "Team Development",
  "team_development_description": "Materials for developing your team",
  "business_documents": "Business Documents",
  "business_documents_description": "Essential documents for running your business",
  "product_content": "Product Content",
  "product_content_description": "Detailed content about Unicity products",
  "americas_convention_desc": "The best minds in health, business, and leadership are taking the stage at the <0>2025 Americas Convention</0> on <0>November 8</0> at the <0>Marriott World Center in Orlando, Florida</0>! Get ready to be inspired, gain powerful insights, and walk away with new perspectives to elevate your success.",
  "americas_convention_popup_title": "Big news: 2025 Convention speakers are now released!",
  "qualified_badge_text": "QUALIFIED",
  "book_now": "Book Now",
  "upcoming_events": "Upcoming Events",
  "method_event_card_description": "You've earned your spot. Join top leaders for two days of exclusive training, recognition, and strategy sessions.",
  "theme_settings": "Theme Settings",
  "use_device_settings": "Use device settings",
  "choose_your_preferred_theme": "Choose your preferred theme",
  "leg3": "Leg 3",
  "_meta.description": "Translation table for AccessibilityController and all AccessibilityTools components",
  "_meta.version": "1.0.0",
  "_meta.components": "AccessibilityController, VisualAccessibility, TextSize, LayoutInteraction, MotionAnimation, FocusNavigation, ReadingComprehension, ColorVisibility, AudioAlerts",
  "accessibility_controller.title": "Accessibility Settings",
  "accessibility_controller.subtitle": "Customize settings for better usability and comfort",
  "accessibility_controller.reset": "Reset",
  "accessibility_controller.reset_description": "Reset to default accessibility settings",
  "accessibility_menu.visual_accessibility": "Visual Accessibility",
  "accessibility_menu.visual_accessibility_description": "High contrast and visual enhancements",
  "accessibility_menu.text_size": "Text Size",
  "accessibility_menu.text_size_description": "Font scaling and typography",
  "accessibility_menu.layout_interaction": "Layout & Interaction",
  "accessibility_menu.layout_interaction_description": "Spacing and touch targets",
  "accessibility_menu.motion_animation": "Motion & Animation",
  "accessibility_menu.motion_animation_description": "Animation and motion controls",
  "accessibility_menu.focus_navigation": "Focus & Navigation",
  "accessibility_menu.focus_navigation_description": "Keyboard navigation and focus",
  "accessibility_menu.reading_comprehension": "Reading & Comprehension",
  "accessibility_menu.reading_comprehension_description": "Text spacing and reading aids",
  "accessibility_menu.color_visibility": "Color & Visibility",
  "accessibility_menu.color_visibility_description": "Color adjustments and visibility",
  "accessibility_menu.audio_alerts": "Audio & Alerts",
  "accessibility_menu.audio_alerts_description": "Sound and notification settings",
  "visual_accessibility.title": "Visual Accessibility",
  "visual_accessibility.description": "High contrast and visual enhancements",
  "visual_accessibility.tooltip": "This setting helps people with visual impairments or anyone who has trouble reading text on screens. High contrast mode makes text darker and backgrounds lighter (or vice versa) to create stronger visual separation. This is especially helpful in bright environments or for users with low vision, dyslexia, or eye strain.",
  "visual_accessibility.high_contrast_mode": "High Contrast Mode",
  "visual_accessibility.high_contrast_description": "Enhances text visibility with stronger color contrasts for improved readability",
  "visual_accessibility.high_contrast_active": "✓ High contrast mode is active. Text and interface elements will have enhanced visibility.",
  "visual_accessibility.preview": "Preview",
  "visual_accessibility.contrast_comparison": "Contrast Comparison",
  "visual_accessibility.default_mode": "Default Mode",
  "visual_accessibility.high_contrast_mode_title": "High Contrast Mode",
  "visual_accessibility.regular_text_contrast": "Regular text contrast",
  "visual_accessibility.enhanced_text_contrast": "Enhanced text contrast",
  "visual_accessibility.standard_colors_spacing": "Standard colors & spacing",
  "visual_accessibility.bold_colors_borders": "Bold colors & borders",
  "visual_accessibility.interactive_elements": "Interactive Elements",
  "visual_accessibility.button": "Button",
  "visual_accessibility.wcag_guidelines": "WCAG Guidelines",
  "visual_accessibility.wcag_description": "Meets Web Content Accessibility Guidelines (WCAG) 2.1 Level AA standards for color contrast ratios (4.5:1 for normal text, 3:1 for large text).",
  "text_size.title": "Text Size",
  "text_size.description": "Adjust font size for better readability",
  "text_size.tooltip": "Make text larger or smaller to match your comfort level. Larger text is easier to read for people with vision difficulties, older adults, or anyone reading on smaller screens. Smaller text can fit more content on screen for users who prefer dense layouts. Choose the size that feels most comfortable for your eyes.",
  "text_size.font_scaling": "Font Scaling",
  "text_size.size_labels.small": "Small",
  "text_size.size_labels.medium": "Medium",
  "text_size.size_labels.large": "Large",
  "text_size.size_labels.extra_large": "Extra Large",
  "text_size.current_size": "Current size",
  "text_size.preview": "Preview",
  "text_size.sample_text": "Sample text at current size setting",
  "text_size.interface_elements": "Interface Elements",
  "text_size.text_samples": "Text Samples",
  "text_size.heading_text": "This is a heading",
  "text_size.paragraph_text": "This is paragraph text that shows how readable content appears at different font sizes. Larger text is especially helpful for users with visual impairments.",
  "text_size.small_text": "Small details and captions",
  "text_size.guidelines": "Guidelines",
  "text_size.wcag_description": "WCAG 2.1 recommends that users should be able to zoom text up to 200% without horizontal scrolling. Larger text also helps with reading comprehension and reduces eye strain.",
  "layout_interaction.description": "Spacing and touch targets",
  "layout_interaction.tooltip": "Control how much space appears around buttons, text, and other elements. 'Spacious' gives more breathing room and larger touch areas, making it easier to tap buttons on mobile devices or for users with motor difficulties. 'Compact' fits more content on screen but requires more precise interaction. Choose what feels most comfortable for your device and abilities.",
  "layout_interaction.content_spacing": "Content Spacing",
  "layout_interaction.content_spacing_description": "Amount of space between interface elements",
  "layout_interaction.touch_target_size": "Touch Target Size",
  "layout_interaction.touch_target_size_description": "Minimum size for buttons and interactive elements",
  "layout_interaction.spacing_options.compact": "Compact",
  "layout_interaction.spacing_options.comfortable": "Comfortable",
  "layout_interaction.spacing_options.spacious": "Spacious",
  "layout_interaction.touch_target_options.standard": "Standard",
  "layout_interaction.touch_target_options.large": "Large",
  "layout_interaction.touch_target_options.extra_large": "Extra Large",
  "layout_interaction.preview": "Preview",
  "layout_interaction.interface_elements": "Interface Elements",
  "layout_interaction.touch_targets": "Touch Targets",
  "layout_interaction.guidelines": "Accessibility Guidelines",
  "layout_interaction.wcag_description": "WCAG 2.1 Level AAA requires touch targets to be at least 44x44 pixels. Adequate spacing prevents accidental activation and improves usability for all users.",
  "motion_animation.title": "Motion & Animation",
  "motion_animation.description": "Animation and motion controls",
  "motion_animation.tooltip": "Control animations and motion effects. Reducing motion helps users with vestibular disorders, seizure conditions, or attention difficulties. Some users find animations distracting or physically uncomfortable. This setting affects transitions, auto-playing videos, and animated elements throughout the interface.",
  "motion_animation.reduce_motion": "Reduce Motion",
  "motion_animation.reduce_motion_description": "Minimize animations and motion effects",
  "motion_animation.reduce_motion_active": "✓ Motion reduction is active. Animations will be minimized or disabled.",
  "motion_animation.animation_speed": "Animation Speed",
  "motion_animation.animation_speed_description": "Control the speed of interface animations",
  "motion_animation.auto_play": "Auto-play Media",
  "motion_animation.auto_play_description": "Control automatic media playback",
  "motion_animation.speed_options.slow": "Slow",
  "motion_animation.speed_options.normal": "Normal",
  "motion_animation.speed_options.fast": "Fast",
  "motion_animation.speed_options.instant": "Instant",
  "motion_animation.auto_play_options.enabled": "Enabled",
  "motion_animation.auto_play_options.disabled": "Disabled",
  "motion_animation.preview": "Preview",
  "motion_animation.animation_demo": "Animation Demo",
  "motion_animation.pulsing_dot": "Pulsing dot",
  "motion_animation.sliding_box": "Sliding box",
  "motion_animation.rotating_element": "Rotating element",
  "motion_animation.auto_play_demo": "Auto-play Demo",
  "motion_animation.video_autoplay": "Video auto-play",
  "motion_animation.guidelines": "Guidelines",
  "motion_animation.wcag_description": "WCAG 2.1 requires that users can pause, stop, or hide moving content that lasts more than 5 seconds. Motion reduction helps users with vestibular disorders and attention difficulties.",
  "focus_navigation.title": "Focus & Navigation",
  "focus_navigation.description": "Keyboard navigation and focus",
  "focus_navigation.tooltip": "Enhance keyboard navigation and focus indicators. These settings help users who navigate with keyboards, screen readers, or other assistive devices. Visible focus rings and skip links make it easier to understand where you are on the page and move efficiently through content.",
  "focus_navigation.show_focus_rings": "Show Focus Rings",
  "focus_navigation.show_focus_rings_description": "Visible indicators around focused elements",
  "focus_navigation.enhanced_keyboard_nav": "Enhanced Keyboard Navigation",
  "focus_navigation.enhanced_keyboard_nav_description": "Additional keyboard shortcuts and navigation aids",
  "focus_navigation.skip_links": "Skip Links",
  "focus_navigation.skip_links_description": "Skip Links Active: Skip links allow keyboard and screen reader users",
  "focus_navigation.focus_timeout": "Focus Timeout",
  "focus_navigation.focus_timeout_description": "How long focus remains on elements",
  "focus_navigation.timeout_options.short": "Short",
  "focus_navigation.timeout_options.medium": "Medium",
  "focus_navigation.timeout_options.long": "Long",
  "focus_navigation.timeout_options.never": "Never",
  "focus_navigation.preview": "Preview",
  "focus_navigation.focus_indicators": "Focus Indicators",
  "focus_navigation.keyboard_shortcuts": "Keyboard Shortcuts",
  "layout_interaction.title": "Layout & Interaction",
  "focus_navigation.tab_navigation": "Tab navigation",
  "focus_navigation.enter_activation": "Enter activation",
  "focus_navigation.arrow_navigation": "Arrow navigation",
  "focus_navigation.skip_navigation": "Skip Navigation",
  "focus_navigation.skip_to_content": "Skip to content",
  "focus_navigation.skip_to_navigation": "Skip to navigation",
  "focus_navigation.guidelines": "Guidelines",
  "focus_navigation.wcag_description": "WCAG 2.1 requires that all interactive elements are keyboard accessible and have visible focus indicators. Skip links help screen reader users navigate efficiently.",
  "reading_comprehension.title": "Reading & Comprehension",
  "reading_comprehension.description": "Text spacing and reading aids",
  "reading_comprehension.tooltip": "Adjust text layout for better reading comprehension. These settings help users with dyslexia, learning differences, or anyone who struggles with dense text. Proper spacing, highlighting, and reading guides can significantly improve comprehension and reduce cognitive load.",
  "reading_comprehension.reading_mode": "Reading Mode",
  "reading_comprehension.reading_mode_description": "Enhanced reading experience",
  "reading_comprehension.line_height": "Line Height",
  "reading_comprehension.line_height_description": "Space between lines of text",
  "reading_comprehension.letter_spacing": "Letter Spacing",
  "reading_comprehension.letter_spacing_description": "Space between individual letters",
  "reading_comprehension.word_spacing": "Word Spacing",
  "reading_comprehension.word_spacing_description": "Space between words",
  "reading_comprehension.reading_guide": "Reading Guide",
  "reading_comprehension.reading_guide_description": "Visual reading assistance",
  "reading_comprehension.typography_spacing_demo": "Typography Spacing Demonstration",
  "reading_comprehension.standard_spacing": "Standard Spacing",
  "reading_comprehension.standard_spacing_description": "This text uses standard spacing values. Notice how the words and letters are positioned normally.",
  "reading_comprehension.custom_spacing": "Your Custom Spacing",
  "reading_comprehension.custom_spacing_description": "This text uses your custom spacing settings. Notice the differences in readability and comfort.",
  "reading_comprehension.interactive_sample": "Interactive Reading Sample",
  "reading_comprehension.spacing_options.tight": "Tight",
  "reading_comprehension.spacing_options.normal": "Normal",
  "reading_comprehension.spacing_options.loose": "Loose",
  "reading_comprehension.spacing_options.extra_loose": "Extra Loose",
  "reading_comprehension.reading_guide_options.none": "None",
  "reading_comprehension.reading_guide_options.underline": "Underline",
  "reading_comprehension.reading_guide_options.highlight": "Highlight",
  "reading_comprehension.reading_guide_options.ruler": "Ruler",
  "reading_comprehension.preview": "Preview",
  "reading_comprehension.text_sample": "This is a sample paragraph that demonstrates how different spacing settings affect readability. Proper line height, letter spacing, and word spacing can significantly improve reading comprehension, especially for users with dyslexia or other reading difficulties.",
  "reading_comprehension.reading_aids": "Reading Aid",
  "reading_comprehension.guidelines": "Guidelines",
  "reading_comprehension.wcag_description": "WCAG 2.1 Level AAA recommends that line spacing is at least 1.5 times the font size, and spacing between paragraphs is at least 2 times the font size.",
  "color_visibility.title": "Color & Visibility",
  "color_visibility.description": "Color adjustments and visibility",
  "color_visibility.tooltip": "Adjust colors and visibility for different types of color vision. These settings help users with color blindness (affecting 8% of men and 0.5% of women) or other visual processing differences. The adjustments ensure important information isn't conveyed by color alone.",
  "color_visibility.color_blind_support": "Color Blind Support",
  "color_visibility.color_blind_support_description": "Color Blind Support: Colors are transformed to be more distinguishable for users with {type} color vision deficiency.",
  "color_visibility.saturation": "Saturation",
  "color_visibility.saturation_description": "Adjust color intensity",
  "color_visibility.brightness": "Brightness",
  "color_visibility.brightness_description": "Adjust overall brightness levels",
  "color_visibility.color_blind_options.none": "None",
  "color_visibility.color_blind_options.protanopia": "Protanopia",
  "color_visibility.color_blind_options.deuteranopia": "Deuteranopia",
  "color_visibility.color_blind_options.tritanopia": "Tritanopia",
  "color_visibility.color_blind_descriptions.none": "No color vision adjustment",
  "color_visibility.color_blind_descriptions.protanopia": "Red-green color blindness (reduced red sensitivity)",
  "color_visibility.color_blind_descriptions.deuteranopia": "Red-green color blindness (reduced green sensitivity)",
  "color_visibility.color_blind_descriptions.tritanopia": "Blue-yellow color blindness (reduced blue sensitivity)",
  "color_visibility.preview": "Preview",
  "color_visibility.color_samples": "Color Samples",
  "color_visibility.system_brand_colors": "System & Brand Colors",
  "color_visibility.primary_color": "Primary",
  "color_visibility.secondary_color": "Secondary",
  "color_visibility.success_color": "Success",
  "color_visibility.warning_color": "Warning",
  "color_visibility.error_color": "Error",
  "color_visibility.info_color": "Info",
  "color_visibility.unicity_brand_chips": "Unicity Brand Chips",
  "color_visibility.progress_indicators": "Progress Indicators",
  "color_visibility.guidelines": "Guidelines",
  "color_visibility.wcag_description": "WCAG 2.1 requires that color is not the only means of conveying information. These adjustments help ensure content is accessible to users with different types of color vision.",
  "audio_alerts.title": "Audio & Alerts",
  "audio_alerts.description": "Sound and notification settings",
  "audio_alerts.tooltip": "Control audio feedback and alert sounds. These settings help users who are deaf or hard of hearing, work in quiet environments, or prefer visual over audio feedback. Sound can also be helpful for users with visual impairments who rely on audio cues for navigation.",
  "audio_alerts.sound_enabled": "Sound Enabled",
  "audio_alerts.sound_enabled_description": "Enable interface sound effects",
  "audio_alerts.volume": "Volume",
  "audio_alerts.volume_description": "Adjust notification volume level",
  "audio_alerts.visual_alerts": "Visual Alerts",
  "audio_alerts.visual_alerts_description": "Show visual notifications instead of sounds",
  "audio_alerts.vibration": "Vibration",
  "audio_alerts.vibration_description": "Tactile feedback for notifications (mobile devices)",
  "audio_alerts.volume_levels.muted": "Muted",
  "audio_alerts.volume_levels.low": "Low",
  "audio_alerts.volume_levels.medium": "Medium",
  "audio_alerts.volume_levels.high": "High",
  "audio_alerts.preview": "Preview",
  "audio_alerts.audio_feedback": "Audio feedback for interactions and notifications",
  "audio_alerts.test_sound": "Test Sound",
  "audio_alerts.play_notification": "Play notification",
  "audio_alerts.play_success": "Play success",
  "audio_alerts.play_error": "Play error",
  "audio_alerts.visual_feedback": "Visual Feedback",
  "audio_alerts.notification_banner": "Notification banner",
  "audio_alerts.success_message": "Success: Action completed successfully",
  "audio_alerts.error_message": "Error: Something went wrong",
  "audio_alerts.haptic_feedback": "Haptic Feedback",
  "audio_alerts.test_vibration": "Test Vibration",
  "audio_alerts.guidelines": "Accessibility Guidelines",
  "audio_alerts.wcag_description": "WCAG 2.1 requires that important information conveyed through audio also has a visual alternative. These settings ensure all users can receive feedback regardless of their hearing ability.",
  "common.enabled": "Enabled",
  "common.disabled": "Disabled",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.on": "ON",
  "common.off": "OFF",
  "common.none": "None",
  "common.low": "Low",
  "common.medium": "Medium",
  "common.high": "High",
  "common.small": "Small",
  "common.large": "Large",
  "common.normal": "Normal",
  "common.fast": "Fast",
  "common.slow": "Slow",
  "common.instant": "Instant",
  "common.short": "Short",
  "common.long": "Long",
  "common.never": "Never",
  "common.compact": "Compact",
  "common.comfortable": "Comfortable",
  "common.spacious": "Spacious",
  "common.standard": "Standard",
  "common.extra_large": "Extra Large",
  "common.extra_loose": "Extra Loose",
  "common.tight": "Tight",
  "common.loose": "Loose",
  "common.muted": "Muted",
  "common.preview": "Preview",
  "common.guidelines": "Guidelines",
  "common.demo": "Demo",
  "common.test": "Test",
  "common.sample": "Sample",
  "common.current": "Current",
  "common.default": "Default",
  "common.custom": "Custom",
  "wcag.aa_compliant": "WCAG AA Compliant",
  "wcag.aaa_compliant": "WCAG AAA Compliant",
  "wcag.contrast_ratio": "Contrast ratio",
  "wcag.meets_standards": "Meets accessibility standards",
  "wcag.exceeds_standards": "Exceeds accessibility standards",
  "visual_accessibility.outlined_button": "Outlined Button",
  "visual_accessibility.wcag_aa": "Standard (WCAG AA)",
  "visual_accessibility.wcag_aaa": "High Contrast (WCAG AAA)",
  "visual_accessibility.current_mode": "Current Mode",
  "visual_accessibility.contrast_ratio": "Contrast Ratio",
  "layout_interaction.content_density": "Content Density",
  "layout_interaction.current_setting": "Current setting",
  "layout_interaction.minimum_size": "Minimum touch target size",
  "layout_interaction.compact_description": "Dense layout, minimal spacing",
  "layout_interaction.comfortable_description": "Balanced spacing for general use",
  "layout_interaction.spacious_description": "Extra spacing for accessibility",
  "layout_interaction.standard_description": "44px minimum (WCAG compliant)",
  "layout_interaction.large_description": "56px recommended size",
  "layout_interaction.extra_large_description": "68px maximum accessibility",
  "layout_interaction.compact_warning": "Compact Layout: May be challenging for users with motor impairments. Consider comfortable or spacious for better accessibility.",
  "layout_interaction.spacious_success": "Spacious Layout: Excellent for accessibility! More breathing room helps users with motor impairments and cognitive processing.",
  "layout_interaction.standard_info": "Standard Touch Targets (44px): Meets WCAG minimum requirements. Consider larger sizes for mobile or accessibility-focused applications.",
  "layout_interaction.large_success": "Large Touch Targets: Excellent choice! 56px+ targets are easier to tap and reduce errors for all users, especially on mobile devices.",
  "text_size.small_warning": "Small Text: May be difficult to read for users with visual impairments. Consider larger sizes for better accessibility.",
  "text_size.large_success": "Large Text: Excellent for accessibility! Benefits users with low vision, dyslexia, and reading difficulties.",
  "text_size.standard_info": "Standard Size: Good baseline that works for most users. Consider larger sizes if accessibility is a priority.",
  "text_size.size_guidelines": "Size Guidelines",
  "text_size.small_guideline": "Small: Compact but may strain eyes",
  "text_size.medium_guideline": "Medium: Web standard, good baseline",
  "text_size.large_guideline": "Large: Improved readability for all users",
  "text_size.extra_large_guideline": "Extra Large: Excellent for accessibility compliance",
  "text_size.current_font_size": "Current font size",
  "common.hover": "HOVER",
  "layout_interaction.density_labels.compact": "Compact",
  "layout_interaction.density_labels.comfortable": "Comfortable",
  "layout_interaction.density_labels.spacious": "Spacious",
  "layout_interaction.touch_target_labels.standard": "Standard",
  "layout_interaction.touch_target_labels.large": "Large",
  "layout_interaction.touch_target_labels.extra_large": "Extra Large",
  "layout_interaction.applied_suffix": "spacing applied",
  "layout_interaction.touch_targets_suffix": "touch targets",
  "layout_interaction.spacing_label": "Spacing: {percent}%",
  "layout_interaction.primary_action": "Primary Action",
  "layout_interaction.secondary_action": "Secondary",
  "layout_interaction.tap_label": "TAP",
  "layout_interaction.accessibility_basic": "Basic",
  "layout_interaction.accessibility_standard": "Standard",
  "layout_interaction.accessibility_enhanced": "Enhanced",
  "text_size.subheading_text": "This is a subheading",
  "text_size.body_text": "This is body text",
  "text_size.caption_text": "This is caption text",
  "text_size.reading_sample": "Reading Sample",
  "text_size.sample_article": "Sample Article:",
  "text_size.sample_paragraph": "This is a sample paragraph to demonstrate how text appears at different font sizes. Good typography improves readability and reduces eye strain, especially for users with visual impairments or reading difficulties.",
  "text_size.current_setting": "Current Setting",
  "focus_navigation.focus_demo": "Focus Ring Demo",
  "focus_navigation.focus_me_tab": "Focus Me (Tab)",
  "focus_navigation.or_this_one": "Or This One",
  "focus_navigation.keyboard_demo": "Keyboard Shortcuts",
  "focus_navigation.skip_links_intro": "Skip links would appear at the top of the page:",
  "focus_navigation.skip_to_footer": "Skip to footer",
  "focus_navigation.focus_timeout_seconds": "Focus Timeout: {seconds} seconds",
  "focus_navigation.focus_timeout_info": "Focus will be maintained for {seconds} seconds after user interaction, helping users with motor impairments who need more time to navigate.",
  "focus_navigation.focus_rings": "Focus Rings",
  "visual_accessibility.benefits": "Benefits",
  "motion_animation.smooth_scrolling": "Smooth Scrolling",
  "focus_navigation.tab_order": "Tab Order",
  "color_visibility.none": "None",
  "color_visibility.protanopia": "Protanopia (Red-blind)",
  "color_visibility.deuteranopia": "Deuteranopia (Green-blind)",
  "color_visibility.tritanopia": "Tritanopia (Blue-blind)",
  "audio_alerts.notification_sounds": "Notification Sounds",
  "audio_alerts.system_sounds": "System Sounds",
  "audio_alerts.volume_labels.off": "Off",
  "audio_alerts.volume_labels.medium": "Medium",
  "audio_alerts.volume_labels.full": "Full",
  "audio_alerts.sound_effects_disabled": "Sound effects disabled",
  "audio_alerts.visual_alerts_enhanced": "Visual alerts are enhanced with pulsing animations and stronger borders",
  "audio_alerts.visual_alerts_subtle": "Visual alerts are subtle and rely on color coding only",
  "motion_animation.speed_labels.off": "Off",
  "motion_animation.speed_labels.slow": "Slow",
  "motion_animation.speed_labels.normal": "Normal",
  "motion_animation.speed_labels.fast": "Fast",
  "motion_animation.speed_descriptions.off": "No animations",
  "motion_animation.speed_descriptions.slow": "Gentle and accessible",
  "motion_animation.speed_descriptions.normal": "Balanced experience",
  "motion_animation.speed_descriptions.fast": "Snappy and responsive",
  "motion_animation.auto_playing_content": "Auto-playing content",
  "motion_animation.click_to_play": "Click to play content",
  "motion_animation.hover_to_see_speed": "Hover to see {speed} animation speed{reduced}",
  "motion_animation.reduced_motion_suffix": " (reduced motion)",
  "motion_animation.reduce_motion_on": "Reduce Motion is ON: Following WCAG guidelines for users with vestibular disorders.",
  "motion_animation.animations_off": "Animations are OFF: All transitions and animations are disabled for maximum accessibility.",
  "motion_animation.autoplay_off": "Auto-play is OFF: Users have control over media playback, preventing unexpected distractions.",
  "motion_animation.speed_guidelines": "Speed Guidelines",
  "motion_animation.slow_guideline": "Slow: Best for users sensitive to motion (0.8s)",
  "motion_animation.normal_guideline": "Normal: Standard web timing (0.3s)",
  "motion_animation.fast_guideline": "Fast: Quick interactions for power users (0.1s)",
  "motion_animation.off_guideline": "Off: No animations for maximum accessibility",
  "motion_animation.current_settings": "Current Settings",
  "focus_navigation.tab_to_see_focus": "Press Tab to see focus rings around interactive elements",
  "focus_navigation.focus_rings_hidden": "Focus rings are hidden. Elements are still focusable but without visual indicators.",
  "focus_navigation.available_shortcuts": "Available Keyboard Shortcuts",
  "focus_navigation.navigate": "Navigate",
  "focus_navigation.activate": "Activate",
  "focus_navigation.skip_to_main": "Skip to main",
  "focus_navigation.skip_to_nav": "Skip to nav",
  "focus_navigation.focus_rings_hidden_warning": "Focus Rings Hidden: This may make navigation difficult for keyboard users. Focus rings are essential for accessibility compliance.",
  "focus_navigation.focus_rings_enabled": "Focus Rings Enabled: Excellent! Visual focus indicators help keyboard users and meet WCAG requirements for accessible navigation.",
  "focus_navigation.enhanced_navigation": "Enhanced Navigation: Additional keyboard shortcuts provide power users",
  "focus_navigation.skip_links_active": "Skip Links Active: Skip links allow keyboard and screen reader users",
  "focus_navigation.navigation_guidelines": "Navigation Guidelines",
  "focus_navigation.focus_rings_guideline": "Focus Rings: Required for WCAG compliance, help keyboard users",
  "focus_navigation.enhanced_nav_guideline": "Enhanced Navigation: Additional shortcuts for power users",
  "focus_navigation.skip_links_guideline": "Skip Links: Essential for screen readers and keyboard navigation",
  "focus_navigation.focus_timeout_guideline": "Focus Timeout: Helpful for users who need more time to navigate",
  "reading_comprehension.letter_spacing_label": "Letter Spacing",
  "reading_comprehension.word_spacing_label": "Word Spacing",
  "reading_comprehension.spacing_labels.normal": "Normal",
  "reading_comprehension.spacing_labels.wide": "Wide",
  "reading_comprehension.spacing_labels.extra_wide": "Extra Wide",
  "color_visibility.color_richness": "Color Richness",
  "color_visibility.richness_labels.muted": "Muted",
  "color_visibility.richness_labels.normal": "Normal",
  "color_visibility.richness_labels.vibrant": "Vibrant",
  "color_visibility.brightness_labels.dim": "Dim",
  "color_visibility.brightness_labels.normal": "Normal",
  "color_visibility.brightness_labels.bright": "Bright",
  "color_visibility.unicity_green": "Unicity Green",
  "color_visibility.unicity_blue": "Unicity Blue",
  "color_visibility.unicity_purple": "Unicity Purple",
  "color_visibility.unicity_orange": "Unicity Orange",
  "color_visibility.unicity_navy": "Unicity Navy",
  "color_visibility.outlined_green": "Outlined Green",
  "color_visibility.outlined_blue": "Outlined Blue",
  "color_visibility.outlined_purple": "Outlined Purple",
  "color_visibility.outlined_orange": "Outlined Orange",
  "color_visibility.outlined_navy": "Outlined Navy",
  "visual_accessibility.high_contrast_on": "High Contrast Mode is ON: Following WCAG AAA guidelines with enhanced",
  "visual_accessibility.standard_mode": "Standard Mode: Using WCAG AA compliant contrast ratios (4.5:1+)",
  "visual_accessibility.contrast_guidelines": "Contrast Guidelines",
  "visual_accessibility.wcag_aa_guideline": "WCAG AA: 4.5:1 contrast ratio for normal text",
  "visual_accessibility.wcag_aaa_guideline": "WCAG AAA: 7:1 contrast ratio for enhanced accessibility",
  "visual_accessibility.high_contrast_guideline": "High Contrast: Bold borders, enhanced text weight, stronger colors",
  "visual_accessibility.benefits_guideline": "Benefits: Helps users with low vision, color blindness, bright environments",
  "common.excellent": "Excellent",
  "common.good": "Good",
  "common.enhanced": "Enhanced",
  "common.basic": "Basic",
  "common.needs_improvement": "Needs Improvement",
  "common.current_layout": "Current layout",
  "common.current_size": "Current size",
  "common.current_setting": "Current Setting",
  "common.current_settings": "Current Settings",
  "common.sample_article": "Sample Article",
  "common.spacing_applied": "spacing applied",
  "common.touch_targets": "touch targets",
  "common.density": "density",
  "common.accessibility": "Accessibility",
  "common.speed": "Speed",
  "common.reduce_motion": "Reduce Motion",
  "common.auto_play": "Auto-play",
  "common.sound": "Sound",
  "common.visual_alerts": "Visual alerts",
  "common.vibration": "Vibration",
  "common.volume": "Volume",
  "common.focus_rings": "Focus rings",
  "common.enhanced_nav": "Enhanced nav",
  "common.skip_links": "Skip links",
  "audio_alerts.sound_controls": "Sound Controls",
  "audio_alerts.sound_description": "Enable or disable sound notifications",
  "audio_alerts.visual_description": "Enhanced visual notifications and indicators",
  "audio_alerts.volume_controls": "Volume Controls",
  "audio_alerts.preview_guidelines": "Preview & Guidelines",
  "audio_alerts.sound_demo": "Sound Demo",
  "audio_alerts.play_sample": "Play Sample",
  "audio_alerts.low_volume": "Low",
  "audio_alerts.high_volume": "High",
  "audio_alerts.notification_example": "Notification example",
  "audio_alerts.visual_demo": "Visual Alerts Demo",
  "audio_alerts.vibration_demo": "Vibration Demo",
  "audio_alerts.vibration_example": "Vibration notification example",
  "audio_alerts.sound_disabled_warning": "Sound Disabled: Users who rely on audio cues may miss important notifications.",
  "audio_alerts.sound_enabled_success": "Sound Alerts Enabled: Good for users who benefit from audio feedback.",
  "audio_alerts.visual_enabled_success": "Visual Alerts Enabled: Excellent for deaf and hard of hearing users.",
  "audio_alerts.multimodal_info": "Multiple Alert Types: Using sound, visual, and vibration provides the most accessible experience.",
  "audio_alerts.alert_guidelines": "Alert Guidelines",
  "audio_alerts.sound_guideline": "Sound: Important for users with visual impairments",
  "audio_alerts.visual_guideline": "Visual Alerts: Essential for deaf/hard-of-hearing users",
  "audio_alerts.vibration_guideline": "Vibration: Useful in noisy environments or for discreet notifications",
  "audio_alerts.multimodal_guideline": "Multiple modes: Best practice for inclusive design",
  "color_visibility.support_description": "Adjust colors for different types of color vision",
  "color_visibility.color_adjustments": "Color Adjustments",
  "color_visibility.color_richness_description": "Adjust color saturation and vibrancy",
  "color_visibility.preview_guidelines": "Preview & Guidelines",
  "color_visibility.color_palette": "Color Palette",
  "color_visibility.palette_description": "How colors appear with current settings",
  "color_visibility.full_spectrum": "Full spectrum",
  "color_visibility.interactive_elements": "Interactive Elements",
  "color_visibility.interactive_description": "Button and interactive element colors",
  "color_visibility.primary_button": "Primary",
  "color_visibility.secondary_button": "Secondary",
  "color_visibility.error_button": "Error",
  "color_visibility.warning_button": "Warning",
  "color_visibility.info_button": "Info",
  "color_visibility.success_button": "Success",
  "color_visibility.unicity_colors": "Unicity Brand Colors",
  "color_visibility.brand_description": "How Unicity brand colors appear with current settings",
  "color_visibility.progress_description": "Progress bars and loading indicators",
  "color_visibility.progress_label": "Progress",
  "motion_animation.autoplay_description": "Control automatic media playback",
  "motion_animation.speed_selection": "Animation Speed",
  "motion_animation.speed_description": "Control animation timing and duration",
  "motion_animation.preview_guidelines": "Preview & Guidelines",
  "motion_animation.autoplay_demo": "Auto-play Demo",
  "motion_animation.media_controls": "Media Controls",
  "layout_interaction.density_description": "Control spacing between interface elements",
  "layout_interaction.touch_description": "Minimum size for interactive elements",
  "layout_interaction.content_demo": "Content Density Comparison",
  "layout_interaction.touch_demo": "Touch Target Size Demo",
  "layout_interaction.layout_guidelines": "Layout Guidelines",
  "layout_interaction.compact_guideline": "Compact: Space-efficient but may hinder accessibility",
  "layout_interaction.comfortable_guideline": "Comfortable: Good balance of space and efficiency",
  "layout_interaction.spacious_guideline": "Spacious: Maximum accessibility with generous spacing",
  "layout_interaction.touch_guideline": "Touch Targets: Minimum 44px recommended by WCAG, 48px+ ideal",
  "focus_navigation.visual_indicators": "Visual Indicators",
  "focus_navigation.navigation_description": "Enhanced keyboard navigation aids",
  "focus_navigation.skip_description": "Quick navigation shortcuts",
  "audio_alerts.sound_effects_description": "Sound effects provide audio feedback for UI interactions like button clicks, notifications, and alerts.",
  "audio_alerts.vibration_mobile": "Vibration (Mobile)",
  "audio_alerts.tactile_feedback": "Tactile feedback for supported devices",
  "audio_alerts.vibration_notification": "Vibration notification example",
  "audio_alerts.accessibility_guidelines": "Accessibility Guidelines",
  "audio_alerts.user_control_guideline": "User Control: Allow volume adjustment and disable options",
  "audio_alerts.haptic_guideline": "Haptic Feedback: Helpful for mobile and accessibility users",
  "audio_alerts.low_volume_warning": "Low Volume: Current volume ({volume}%) may be too quiet for some users or environments.",
  "audio_alerts.volume_display": "Volume: {volume}%",
  "color_visibility.none_option": "None",
  "color_visibility.protanopia_option": "Protanopia",
  "color_visibility.deuteranopia_option": "Deuteranopia",
  "color_visibility.tritanopia_option": "Tritanopia",
  "color_visibility.color_blind_active": "Color Blind Support Active: Colors are adjusted for {type} vision to improve accessibility and color distinction.",
  "color_visibility.color_guidelines": "Color Guidelines",
  "color_visibility.color_blind_guideline": "Color Blind Support: Essential for 8% of men and 0.5% of women",
  "color_visibility.saturation_guideline": "Saturation: Adjust for visual processing or sensory sensitivities",
  "color_visibility.brightness_guideline": "Brightness: Control overall light sensitivity and eye strain",
  "color_visibility.color_only_guideline": "Don't rely on color alone: Use text, icons, and patterns for important information",
  "motion_animation.auto_play_media": "Auto-play Media",
  "motion_animation.disable_auto_play": "Disable auto-playing videos and animations",
  "motion_animation.disabled": "Disabled",
  "motion_animation.gentle_accessible": "Gentle and accessible",
  "motion_animation.balanced_experience": "Balanced experience",
  "motion_animation.snappy_responsive": "Snappy and responsive",
  "reading_comprehension.sample_article": "Sample Article",
  "reading_comprehension.sample_title": "Sample Article: The Benefits of Accessible Typography",
  "reading_comprehension.sample_content": "This is a sample paragraph to demonstrate how text appears with your current reading settings. The spacing between letters, words, and lines can significantly impact readability and comprehension. These adjustments are particularly helpful for people with dyslexia, reading difficulties, or anyone who wants to improve their reading comfort.",
  "focus_navigation.visual_indicators_description": "Visible indicators around focused elements",
  "focus_navigation.navigation_aids_description": "Additional keyboard shortcuts and navigation aids",
  "focus_navigation.skip_shortcuts_description": "Quick navigation shortcuts",
  "focus_navigation.enhanced_nav_description": "Enhanced Navigation: Additional keyboard shortcuts provide power users",
  "layout_interaction.current_layout": "Current layout",
  "layout_interaction.current_size": "Current size",
  "layout_interaction.content_density_comparison": "Content Density Comparison",
  "layout_interaction.touch_target_demo": "Touch Target Size Demo",
  "layout_interaction.default_touch_targets": "Default touch targets",
  "layout_interaction.enlarged_access": "Enlarged for easier access",
  "layout_interaction.maximum_accessibility": "Maximum accessibility",
  "common.enhanced_spacing": "Enhanced Spacing",
  "common.gentle_accessible": "Gentle and accessible",
  "common.balanced_experience": "Balanced experience",
  "common.snappy_responsive": "Snappy and responsive",
  "common.sound_effects": "Sound Effects",
  "common.haptic_feedback": "Haptic Feedback",
  "common.visual_alerts_demo": "Visual Alerts",
  "common.accessibility_guidelines": "Accessibility Guidelines",
  "common.audio_alert_guidelines": "Audio & Alert Guidelines",
  "audio_alerts.haptic_feedback_devices": "Haptic feedback on supported devices",
  "audio_alerts.sound_effects_disabled_label": "Sound effects disabled",
  "audio_alerts.visual_alerts_complement": "Visual alerts complement or replace audio notifications:",
  "audio_alerts.warning_message": "Warning: Please review your input",
  "audio_alerts.no_methods_warning": "No Alert Methods Enabled: Users may miss important notifications. Consider enabling at least one alert method for better accessibility.",
  "audio_alerts.multiple_methods_guideline": "Multiple Methods: Provide audio, visual, and haptic alternatives",
  "audio_alerts.visual_alerts_guideline": "Visual Alerts: Essential for deaf/hard-of-hearing users",
  "audio_alerts.haptic_feedback_guideline": "Haptic Feedback: Helpful for mobile and accessibility users",
  "audio_alerts.sound_effects_guideline": "Sound Effects: Should be pleasant and not overwhelming",
  "audio_alerts.current_settings_summary": "Current Settings: Sound: {sound} • Visual alerts: {visual} • Vibration: {vibration} • Accessibility: {accessibility}",
  "audio_alerts.needs_improvement": "Needs Improvement",
  "audio_alerts.visual_alerts_active": "Visual Alerts Active: Excellent for users with hearing impairments or in noisy environments. Provides visual notification alternatives.",
  "audio_alerts.haptic_feedback_active": "Haptic Feedback Active: Great for mobile users with hearing or visual impairments. Provides tactile notification alternatives.",
  "audio_alerts.low_volume_label": "Low Volume: Current volume ({percent}%) may be too quiet for some users or environments.",
  "audio_alerts.haptic_feedback_mobile": "Haptic Feedback (Mobile)",
  "audio_alerts.haptic_feedback_info": "Haptic feedback provides vibration patterns for notifications and interactions. Helpful for users with hearing impairments or in noisy environments.",
  "reading_comprehension.sample_article_title": "Sample Article: The Benefits of Accessible Typography",
  "reading_comprehension.sample_paragraph": "This is a sample paragraph to demonstrate how text appears with your current reading settings. The spacing between letters, words, and lines can significantly impact readability and comprehension. These adjustments are particularly helpful for people with dyslexia, reading difficulties, or anyone who wants to improve their reading comfort.",
  "reading_comprehension.reading_guide_active": "Reading Guide Active: Hover over the text above to see the reading guide highlight.",
  "reading_comprehension.reading_mode_active": "Reading Mode Active: Layout is simplified with reduced visual distractions",
  "reading_comprehension.low_line_height": "Low Line Height: Line height below 1.5 may be difficult for users with dyslexia",
  "reading_comprehension.good_line_height": "Good Line Height: Line height of {height}",
  "reading_comprehension.enhanced_spacing": "Enhanced Spacing: Additional letter/word spacing can significantly help users",
  "reading_comprehension.reading_mode_benefit": "Reading Mode: Simplified layout reduces cognitive load and helps users",
  "reading_comprehension.reading_guidelines": "Reading Guidelines",
  "color_visibility.color_blind_support_active": "Color Blind Support Active: Colors are adjusted for {type}",
  "color_visibility.low_saturation": "Low Saturation: Very low color saturation may make it difficult",
  "color_visibility.low_brightness": "Low Brightness: Very dark colors may be difficult to see",
  "color_visibility.color_blind_support_desc": "Color Blind Support: Colors are transformed to be more distinguishable",
  "color_visibility.brightness_accommodation": "Brightness: Accommodate different viewing environments",
  "color_visibility.dont_rely_color": "Don't rely on color alone: Use icons, text, and patterns too",
  "color_visibility.current_settings": "Current Settings: Color Blind: {colorBlind} •",
  "tc_agreement_checkbox_label": "I agree to the Distributor",
  "tc_agreement_link_text": "Terms & Conditions.",
  "tc_snackbar_message": "Accepting the updated Terms & Conditions is required to ensure your earnings remain secure. Declining may delay or block payouts.",
  "tc_e_signature_label": "E-Signature",
  "tc_e_signature_placeholder": "Full Name",
  "tc_full_text_part1": "By checking this box and submitting this form with payment of my Distributor Enrollment fee, I indicate my intent to register as a Unicity Distributor, and certify that I have received, read, understand, and agree to the current Unicity",
  "tc_full_text_part2": "I have also received, read, understand, and agree to the Unicity",
  "tc_full_text_part3": ", all of which are incorporated herein and made part of this agreement. Finally, as a Unicity Distributor, I consent to Unicity contacting me at the telephone and fax number(s) and/or e-mail address I have provided with my application.",
  "tc_policies_and_procedures": "Policies and Procedures",
  "tc_terms_and_conditions": "Terms & Conditions",
  "tc_compensation_plan": "Compensation Plan",
  "tc_and": "and",
  "view_video": "View Video",
  "view_audio": "View Audio",
  "view_pdf": "View PDF",
  "view_spreadsheet": "View Spreadsheet",
  "view_presentation": "View Presentation",
  "accessibility": "Accessibility",
  "welcome_to_new_library_v2": "Welcome to the New Library, a resource center for everything that will support your business.",
  "go_back_to_previous_version": "Go back to a previous version of Library",
  "here": "Here",
  "video_player": "Video Player",
  "invalid_youtube_url": "Invalid YouTube URL. Please check the link and try again.",
  "referral_links_2_0.title": "Welcome to your Referral Link Center",
  "referral_links_2_0.subtitle": "Use these universal links to grow your business",
  "referral_links_2_0.campaign.distributor_enrollment": "Distributor Enrollment",
  "referral_links_2_0.campaign.distributor_enrollment_description": "Enroll a new Distributor onto your team",
  "referral_links_2_0.campaign.feel_great_pack": "Feel Great Pack",
  "referral_links_2_0.campaign.feel_great_pack_description": "Feel Great is designed to bridge the gap between where you are and where you want to be.",
  "referral_links_2_0.campaign.stronghold_pack": "Stronghold Pack",
  "referral_links_2_0.campaign.stronghold_pack_description": "Stronghold is a scientifically formulated muscle-support supplement designed to combat anabolic resistance and preserve strength as you age.",
  "referral_links_2_0.link_copied_to_clipboard": "Link {{link}} copied to clipboard",
  "referral_links_2_0.campaign.ushop_pack": "Unicity uShop",
  "referral_links_2_0.campaign.ushop_pack_description": "Browse products available in other countries",
  "referral_links_2_0.additional_links_title": "Additional Links",
  "referral_links_2_0.additional_links_subtitle": "To browse products available in other countries, please <0/>",
  "referral_links_2_0.additional_links_subtitle_link": "switch country →",
  "referral_links_2_0": "Referral Links",
  "product_drawer.title": "Product Details",
  "product_drawer.tab.shop": "Shop",
  "product_drawer.tab.feel_great": "Feel Great",
  "product_drawer.tab.stronghold": "Stronghold",
  "product_drawer.link.standard_link": "Standard Link",
  "product_drawer.link.standard_link_description": "Share this product and allow browsing of all other products",
  "product_drawer.link.focus_link": "Focus Link",
  "product_drawer.link.focus_link_description": "Share this product and hide all other products",
  "product_drawer.link.clean_mode": "Clean Mode",
  "product_drawer.link.clean_mode_description": "Share this product and hide all Unicity branding",
  "otp_login_link": "One Time Passcode",
  "otp_email_placeholder": "Email address",
  "otp_send_code": "Send Passcode",
  "otp_sent_confirmation": "Your One Time Passcode has been sent to",
  "otp_expiry_notice": "This code will expire in 30min.",
  "otp_resend_available": "Re-send Passcode",
  "otp_resend_sent": "A new passcode has been sent!",
  "otp_verify_button": "Verify",
  "otp_back_to_login": "Back to Login",
  "otp_invalid_code": "Please enter a valid passcode",
  "otp_code_expired": "Code expired. Please request a new one.",
  "otp_login_failed": "Login failed. Please try again.",
  "otp_account_not_found": "Account not found. Please check your email address.",
  "otp_resend_failed": "Failed to resend. Please try again."
};
